import React from "react";

const Footer = () => {
  return (
    <div className="p-5">
      <p className="text-center">
        All rights reserved &copy; 2022 | Untitled Dev [Ebraj]
      </p>
    </div>
  );
};

export default Footer;
